module.exports = __webpack_public_path__ + "media/floorPlans/floorPlansBackground-f4a5db91.png";